import React from 'react';

/**
 * Error boundary specifically for suppressing ResizeObserver errors
 * This catches ResizeObserver errors that might slip through other suppression methods
 */
class ResizeObserverErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Check if this is a ResizeObserver error
    if (error && error.message && error.message.includes('ResizeObserver loop completed')) {
      // Don't update state for ResizeObserver errors - just ignore them
      return null;
    }
    
    // For other errors, update state to show fallback UI
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Check if this is a ResizeObserver error
    if (error && error.message && error.message.includes('ResizeObserver loop completed')) {
      // Silently ignore ResizeObserver errors
      return;
    }
    
    // Log other errors normally
    console.error('Error caught by ResizeObserverErrorBoundary:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // Fallback UI for non-ResizeObserver errors
      return (
        <div style={{ padding: '20px', textAlign: 'center' }}>
          <h2>Something went wrong.</h2>
          <p>Please refresh the page or try again later.</p>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ResizeObserverErrorBoundary;
